import { useRef } from "react";
import { Textarea } from "@/components/ui/textarea";

const IDLE_GAP_MS = 60000;

// Textarea that records paste share and active writing time for the AI scan.
export const TrackedAnswer = ({ value, onChange, placeholder, testId }) => {
  const stats = useRef({ pasted_chars: 0, paste_events: 0, keystrokes: 0, active_ms: 0, last: 0 });

  const tick = () => {
    const s = stats.current; const now = Date.now();
    if (s.last && now - s.last < IDLE_GAP_MS) s.active_ms += now - s.last;
    s.last = now;
  };
  const emit = (text) => {
    const s = stats.current;
    onChange(text, { pasted_chars: s.pasted_chars, paste_events: s.paste_events, keystrokes: s.keystrokes, active_seconds: Math.round(s.active_ms / 1000) });
  };

  return (
    <Textarea
      value={value}
      placeholder={placeholder}
      className="min-h-[140px] text-sm"
      data-testid={testId}
      onKeyDown={() => { stats.current.keystrokes += 1; tick(); }}
      onPaste={(e) => { const t = e.clipboardData.getData("text") || ""; stats.current.pasted_chars += t.length; stats.current.paste_events += 1; tick(); }}
      onChange={(e) => emit(e.target.value)}
    />
  );
};
